module.exports = __webpack_public_path__ + "static/img/sch-process.3932c3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sch-process.png
// module id = cjrt
// module chunks = 1